(() => {
  'use strict';

  const sourceSelector = 'template[data-mu-image-badge-source]';
  const containerSelector = '[data-product-badge], [data-product-single-badge]';

  const mountBadge = (source) => {
    const container = source.previousElementSibling;

    if (!container || !container.matches(containerSelector)) return;
    if (container.querySelector('[data-mu-image-badge]')) return;

    container.appendChild(source.content.cloneNode(true));
  };

  const collectSources = (node, sources) => {
    if (node.nodeType !== Node.ELEMENT_NODE) return;

    if (node.matches(sourceSelector)) sources.add(node);
    node.querySelectorAll(sourceSelector).forEach((source) => sources.add(source));
  };

  const initialize = () => {
    // Restore only our image after Kalles builds or refreshes native badges.
    // Also mount sources inserted by filters, pagination, quick view or sliders.
    const observer = new MutationObserver((records) => {
      const sources = new Set();

      records.forEach((record) => {
        const target = record.target;

        if (target.nodeType === Node.ELEMENT_NODE && target.matches(containerSelector)) {
          const source = target.nextElementSibling;
          if (source && source.matches(sourceSelector)) sources.add(source);
        }

        record.addedNodes.forEach((node) => collectSources(node, sources));
      });

      sources.forEach((source) => {
        if (source.isConnected) mountBadge(source);
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
    document.querySelectorAll(sourceSelector).forEach(mountBadge);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
